export const images = {
    logo: require('./eventox/logo.png'),
    eventox_logo: require('./eventox/logo1.png'),
    eventox_blackLogo: require('./eventox/EVENTOX_LOGO.png'),
    // Logos from Downloads/eventox mock for the new glass shell
    eventox_logo_dark: require('./eventox/eventox_logo_dark.png'),
    eventox_light: require('./eventox/eventox_light.png'),
    grey_logo: require('./eventox/grey_logo.png'),
    white_icon: require('./eventox/white_icon.png'),
    defaultProfileIcon: require('./eventox/default-profile-icon.jpg'),
    calendar:require('./eventox/calendar.png'),
    ticket:require('./eventox/ticket.png'),
    noEvent:require('./eventox/no-event-placeholder.jpg'),
    standardWebinar:require('./eventox/icon/standard-webinar.png'),
    training:require('./eventox/icon/health-and-welbeing.png'),
    onlineClasses:require('./eventox/icon/e-learning.png'),
    talkShow:require('./eventox/icon/talk-show-1.png'),
    defaultEventBanner:require('./banner.jpg'),
    discount:require('./discount.png'),
    profile:require('./profile.jpg'),
    learnMore:{
        isOtherAttendeeRequired:require('./learn-more/isOtherAttendeeRequired.png'),
        showOtherFees:require('./learn-more/showOtherFees.png'),
        multipleTicketGroups:require('./learn-more/multipleTicketGroups.png'),
    }

    


    
    
  
}